import request from '@/utils/request'
import requestNoToken from '@/utils/requestNoToken'
import axios from 'axios'
import Qs from 'qs'

export function loginByUsername1(email, password, rememberMe) {
  const data = {
    email,
    password,
    rememberMe
  }
  let r = request({
    url: '/auth/login',
    method: 'post',
    data
  })
  console.log(r)
  return r;
}

export function loginByUsername(username, password, isRead) {
  return new Promise((res, rej) => {
    let r = {
      code: 200,
      message: 'ok',
      data: {
        errno: 0,
        errmsg: '成功',
        data: 'aeiou'
      }
    }
    res(r)
  })
}

export function logout(userId) {
  return request({
    url: '/auth/logOut',
    method: 'get',
    params: {userId}
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function googleLogin() {
  return request({
    url: '/auth/getGoogleRedirectUri',
    method: 'get'
  })
}

export function addCarByString(query) {
  return request({
    url: '/car/addCarByString',
    method: 'get',
    params: query,
  })
}

export function requestGoogle(url) {
  let a = axios(url, {
    method: 'GET',
    timeout: 30000,
  })
  console.log(a)
  return a;
}

export function loginGoogle(code) {
  return request({
    url: '/auth/loginGoogle',
    method: 'get',
    params: {code: code}
  })
}

export function facebookLogin() {
  return request({
    url: '/auth/getFacebookRedirectUri',
    method: 'get'
  })
}

export function loginFacebook(code) {
  return request({
    url: '/auth/loginFacebook',
    method: 'get',
    params: {code: code}
  })
}

export function checkAccount(checkAccount) {
  return request({
    url: '/auth/checkAccount',
    method: 'get',
    params: {checkAccount}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js